import { base } from "./base";
import { loaderEndHook } from "./hooks/(afterResponse)/loaderEnd";
import { loaderErrorHook } from "./hooks/(beforeError)/loaderError";
import { loaderStartHook } from "./hooks/(beforeRequest)/loaderStart";

// Public instance: loader only, no auth, no token-refresh hooks.
// Intentionally kept free of tokenRefresh.ts imports so hook files can
// safely import this without creating a circular dependency.
export const httpPublic = base.extend({
  hooks: {
    afterResponse: [loaderEndHook],
    beforeError: [loaderErrorHook],
    beforeRequest: [loaderStartHook],
  },
});
